const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const streamStaffAi = async (path, payload, onText) => {
  const response = await fetch(`${API}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    let message = "AI request failed";
    try {
      const data = await response.json();
      message = data.detail || message;
    } catch (error) {}
    throw new Error(message);
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let output = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const events = buffer.split("\n\n");
    buffer = events.pop() || "";
    for (const event of events) {
      const line = event.split("\n").find((item) => item.startsWith("data: "));
      if (!line) continue;
      const data = JSON.parse(line.slice(6));
      if (data.error) throw new Error(data.error);
      if (data.delta) {
        output += data.delta;
        onText(output);
      }
      if (data.done) return output;
    }
  }
  return output;
};
